import { authenticatedGet } from '../shared/awsApiClientMethods';
import { LOCALE } from 'src/dataLayer/env';

export default () =>
  authenticatedGet({
    path: `v1.2.0/${ LOCALE }/users/me`
  }).then((response) => ({ authenticationToken: response.data.user.authentication_token }));
